{
  "$id": "wealthlane://forms/company-mapping/rules",
  "$schema": "wealthlane://schemas/form-rules",
  "effects": [],
  "observers": [],
  "rules": []
}
